import React, { useState } from "react";
import { Card, Typography, Row, Col, Space, Divider, Avatar, message } from "antd";
import { QuestionCircleOutlined, UserOutlined, EditOutlined } from "@ant-design/icons";
import { routes } from "../../../routes/Routes";
import { useHistory } from "react-router-dom";
import _commonService from "../../../modules/commonService";
const { Text, Title } = Typography;

const PreviewGeneralInfoForConsumer = ({ applnObjId, applicantInfo }) => {
  const history = useHistory();
  const [applicationObjId] = useState(applnObjId);

  // const editApplicantInfo = () => {
  //   history.push({
  //     pathname: routes.ApplicantsDetails.path,
  //     state: { applicationObjId: applicationObjId || localStorage.getItem("ApplicationObjId"), isFromDashboard: true },
  //   });
  // }

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 16,
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.06)",
      }}
      bodyStyle={{ padding: 20 }}
      className="cardBodyPadding"
    >
      {/* Header Row */}
      <Row justify="space-between" align="middle" className="leftsidebox">
        <Space>
          <Avatar icon={<UserOutlined />} size="small" />
          <Text strong>Personal Details</Text>
        </Space>
        {/* <EditOutlined className="editIconClass" onClick={editApplicantInfo} style={{ color: "#595959", cursor: "pointer" }} /> */}
      </Row>

      <Divider style={{ margin: '12px 0' }} />

      {/* Applicant Type */}
      {/* <Row justify={"space-between"} gutter={8}>

        <Col>
          <Text strong style={{ fontSize: 14 }}>Application Type</Text><br />
          <Text style={{ fontSize: 13 }}>{applicantInfo && applicantInfo.ApplicantType}</Text>
        </Col>
        <Col>
          <Avatar icon={<UserOutlined />} size="small" />
        </Col>
      </Row> */}

      {/* Info List */}
      <div>
        {[
          { label: "First Name", value: applicantInfo && applicantInfo.FirstName || "N/A" },
          { label: "Last Name", value: applicantInfo && applicantInfo.LastName || "N/A"},
          { label: "Date Of Birth", value: applicantInfo && applicantInfo.DateOfBirth ? _commonService.formatDateWithSuffix(applicantInfo.DateOfBirth) : "N/A"},
          { label: "Contact No.", value: applicantInfo && applicantInfo.Phone ? _commonService.formatUSPhoneNumber(applicantInfo.Phone) : "N/A" },
          { label: "Email", value: applicantInfo && applicantInfo.Email || "N/A" },
          { label: "City", value: applicantInfo && applicantInfo.City || "N/A" },
          { label: "State", value: applicantInfo && applicantInfo.State || "N/A" },
          { label: "Zip Code", value: applicantInfo && applicantInfo.Zip || "N/A" },
        ].map((item) => (
          <Row key={item.label} style={{ marginBottom: 4 }}>
            <Col span={10}>
              <Text type="secondary">{item.label}:</Text>
            </Col>
            <Col span={14}>
              <Text>{item.value}</Text>
            </Col>
          </Row>
        ))}
      </div>

      <Divider style={{ margin: '12px 0' }} />

      {/* Loan Inquiry */}
      <Row align="middle">
        {/* <Avatar
            icon={<QuestionCircleOutlined />}
            size="small"

          /> */}
        <Text strong>Requested Loan Amount:</Text>
        <Text className="ml10" strong>{applicantInfo && applicantInfo.Cons_ApproximateLoanSize ? `$ ${_commonService.formatNumberWithCommas(applicantInfo.Cons_ApproximateLoanSize)}` : "N/A"}</Text>
      </Row>
    </Card>
  )
}
export default PreviewGeneralInfoForConsumer;